export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-100-normal.woff?bf6f91d32ab7f24a137e8e15f6346709";